.theme-brand-signnow {
  .sn-call-to-action-type-2 {
    .call-to-action-type-2__content {
      overflow: hidden;
      border: 0;
      border-radius: map-get($border-radii, lg);
      background: $color-brand-primary-darkest;
      color: $color-neutral-white;
    }

    .me-button--secondary,
    .me-button--primary {
      padding: map-get($spacings, sm) map-get($spacings, 2xl);
    }

    .call-to-action-type-2__intro {
      padding: map-get($spacings, 4xl);
      text-align: center;

      @include above($breakpoint-desktop-md) {
        padding: map-get($spacings, 6xl) map-get($spacings, xl) map-get($spacings, 6xl) map-get($spacings, 6xl);
        text-align: left;
      }

      .me-text--label {
        text-transform: uppercase;
        letter-spacing: 3px;
        font-size: map-get($font-sizes, xs);
        font-weight: map-get($font-weights, bold);
      }

      .me-heading {
        margin-bottom: map-get($spacings, 4xl);
      }

      .call-to-action-type-2 {
        .call-to-action-type-2__content {
          overflow: hidden;
          border: 0;
          border-radius: map-get($border-radii, lg);
          background: $color-brand-primary-darkest;
        }

        .call-to-action-type-2__intro {
          color: $text-color-alternate;
        }
      }

      .me-row.me-row--wrap-wrap {
        @include below($breakpoint-desktop) {
          max-width: 312px;
          margin: 0 auto;
        }
      }
    }

    .call-to-action-type-2__media {
      display: none;

      @include above($breakpoint-desktop-md) {
        display: block;
        padding: map-get($spacings, 6xl) map-get($spacings, 7xl) map-get($spacings, 6xl) 0;
      }

      .cta-list {
        display: flex;
        flex-direction: column;
        gap: map-get($spacings, 3xl);

        .cta-list__item {
          display: flex;
          align-items: center;
          gap: map-get($spacings, xl);

          .cta-list__logo img {
            min-width: 44px;
          }
        }

        .cta-list__description {
          font-family: Graphik, Arial, sans-serif;
          font-size: map-get($font-sizes, md);
          line-height: map-get($line-heights, md);

          @include desktop-lg {
            font-size: map-get($font-sizes, lg);
            line-height: map-get($line-heights, lg);
          }
        }
      }
    }
  }
}
